import { configureStore } from "@reduxjs/toolkit";
import permissionsReducer from "./slices/permissionsSlice";

export const store = configureStore({
    reducer: {
        permissions: permissionsReducer,
    },
});

export default store;
